import { createFileRoute } from "@tanstack/react-router";

import { OrgUsagePage } from "../iam/organization/components/OrgUsagePage";

/**
 * Route is /organizations/$organizationId/usage: the organization's dedicated Usage page
 * (the month's Data API and Tile API requests against the allowances of its agreement, and the
 * usage filters and charts), split out from the Billing page so consumption stays separate from the plan and
 * money concerns. Open to every role — the page renders the self-loading usage section —
 * while the nav surfaces this entry to admins only, since usage is a billing-manager concern.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/usage")({
  component: OrgUsagePage,
});
